import IconPlanningStep1 from '../../../shared/Icons/IconPlanningStep1.svelte';
import IconPlanningStep2 from '../../../shared/Icons/IconPlanningStep2.svelte';
import IconPlanningStep3 from '../../../shared/Icons/IconPlanningStep3.svelte';
import IconPlanningStep4 from '../../../shared/Icons/IconPlanningStep4.svelte';

// unassigned | suggestions | jobs | in_progress
export type QuickCategoriesIdType = 'to_assign' | 'to_approve' | 'to_send' | 'in_progress';
export type QuickCategoriesIdEmptyType = '';

export type QuickCategoriesType = {
    id: QuickCategoriesIdType;
    // title: string;
    quantity: number;
    adhoc: number;
    iconComponent: any;
    color: string;
    backgroundColor: string;
    borderColor: string;
};

export const quickCategoriesConfig: QuickCategoriesType[] = [
    {
        id: 'to_assign',
        quantity: 0,
        adhoc: 0,
        iconComponent: IconPlanningStep1,
        color: '#3e352e',
        // backgroundColor: '#e7bdf8',
        backgroundColor: '#f0f0f0',
        borderColor: '#3e352e',
    },
    {
        id: 'to_approve',
        quantity: 0,
        adhoc: 0,
        iconComponent: IconPlanningStep2,
        color: '#3e352e',
        // backgroundColor: '#e6f1ff',
        backgroundColor: '#ebf2fc',
        borderColor: '#6fb1ff',
    },
    {
        id: 'to_send',
        quantity: 0,
        adhoc: 0,
        iconComponent: IconPlanningStep3,
        color: '#3e352e',
        // backgroundColor: '#bad1f5',
        backgroundColor: '#e0e9fa',
        borderColor: '#367ff5',
    },
    {
        id: 'in_progress',
        quantity: 0,
        adhoc: 0,
        iconComponent: IconPlanningStep4,
        // color: '#ffffff',
        color: '#3e352e',
        // backgroundColor: '#527aba',
        backgroundColor: '#ceddfa',
        borderColor: '#22447a',
    },
];
